import React, { useState, useEffect, useRef, useContext } from 'react';
import Dustbin from '../../../Assets/Images/dustbin.svg';
import CloseIcon from '@mui/icons-material/Close';
import { CircularProgress, IconButton } from '@mui/material';
import { deleteNotificationById, deleteNotificationsByOrgId, getNotification, listenForNotifications, markAllNotificationsAsRead, markAllNotificationsAsReadByOrgId, markAllNotificationsAsUnRead, updateNotificationById } from '../../../api';
import AuthContext from '../../../Context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { DashboardContext } from '../../../Context/DashboardContext';
import noNotification from '../../../Assets/Images/no-notification.svg'

const Notification = ({ isNotificationOpen, handleNotificationClose }) => {

  // other hooks
  const navigate = useNavigate();
  const notificationRef = useRef(null);
  const authCtx = useContext(AuthContext)
  const dashboardCtx = useContext(DashboardContext)

  // useStates 
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false)
  const [hoveredNotificationId, setHoveredNotificationId] = useState(null);
  const [unreadCount, setUnreadCount] = useState(0);

  // useEffects
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        handleNotificationClose();
      }
    };

    const unsubscribe = listenForNotifications((notifications) => {
      const notificationsArray = notifications
        .filter((el) => String(el?.orgId) === String(authCtx?.orgId))
        .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
      // console.log('notificationsArray', notificationsArray)
      setNotifications(notificationsArray);

      const unread = notificationsArray.filter(n => !n.isRead);
      dashboardCtx.setUnreadCount(unread.length);
    });

    document.addEventListener('mousedown', handleOutsideClick);

    // Clean up the event listener and Firebase listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
      unsubscribe();
    };

  }, [authCtx?.orgId]);

  useEffect(() => {
    const notificationActions = async () => {
      const el = document.getElementsByClassName('dashboard-platform')[0];

      if (isNotificationOpen) {
        await markAllNotificationsAsReadByOrgId(authCtx?.orgId)
      }

      if (el && isNotificationOpen) {
        el.style.overflow = "hidden";
      }
      else if (el && !isNotificationOpen) {
        el.style.overflow = "auto";
      }
    }

    notificationActions()
  }, [isNotificationOpen])



  // functions 

  const handleDelete = async (notification) => {
    setIsLoading(true);
    // console.log("notification delete", notification);

    try {
      switch (notification?.notification_type) {
        case 'self_complete':
        case '360_complete':
        case 'all_complete':
        case 'asmt_reminder':
        case 'activate_self_asmt':
        case 'activate_respondent':
        case 'activate_observer':
        case 'client_added':
          await deleteNotificationById(notification?.id);
          break;
        case 'all':
          await deleteNotificationsByOrgId(authCtx?.orgId);
          break;
        default:
          console.warn('Unknown notification type:', notification?.notification_type);
      }
    } catch (error) {
      console.error('Error deleting notification:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const decodeHTML = (str) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  };

  const getNotificationText = (notification) => {
    console.log("notification", notification)

    const capitalizeWords = (str) => { return str?.replace(/\b\w/g, char => char.toUpperCase()) || ''; };

    switch (notification?.notification_type) {
      case "self_complete":
        return <>
          <span className='notification-user-name'>{capitalizeWords(notification?.user_name)}</span> has completed the Self-Assessment!
        </>
        break;
      case "360_complete":
        return (
          <>
            {/* <span className='notification-user-name'>{capitalizeWords(notification?.user_name)}</span>{' '} */}
            <span dangerouslySetInnerHTML={{ __html: notification?.message }} />
          </>
        );
        break;
      case "client_added":
        return <>
          <span className='notification-user-name'>{capitalizeWords(notification?.user_name)}</span><span className='user-name'> has been added as a client:</span>
          <br />
          <span>Add assessments to gather insights</span>
        </>
        break;
      case "all_complete":
        return <>
          <span className='notification-user-name'>{capitalizeWords(notification?.user_name)}:</span> <span>All assessments completed!</span>
        </>
       case 'asmt_reminder':
        return (
          <span dangerouslySetInnerHTML={{ __html: notification?.message }} />
        );
      case "activate_observer":
        return (
          <>
            <span className='notification-user-name'>360 Observer Invitation Sent</span><br />
            <span dangerouslySetInnerHTML={{ __html: notification?.message }} />
          </>
        );
      case "activate_respondent":
        return (
          <>
            <span className='notification-user-name'>Self Assessment Link Sent</span><br />
            <span dangerouslySetInnerHTML={{ __html: notification?.message }} />
          </>
        );

      case "activate_self_asmt":
        return (
          <>
            <span className='notification-user-name'>Self Assessment Link Sent</span><br />
            <span dangerouslySetInnerHTML={{ __html: notification?.message }} />
          </>
        );
    }
  }

  const getNotificationLink = (notification) => {
    const handleClick = (url) => {
      navigate(url);
      handleNotificationClose();
    };

    switch (notification?.notification_type) {
      case "self_complete":
      case "360_complete":
      case "activate_self_asmt":
      case "activate_respondent":
      case "activate_observer":
        return (
          <a onClick={() => handleClick(`/client/${notification?.clientId}?tab=1`)} style={{ cursor: "pointer" }} rel="noopener noreferrer" className={notification.id === hoveredNotificationId ? 'underlined' : ''} >
            Go to Clients
          </a>
        );

      case "client_added":
        return (
          <a onClick={() => handleClick(`/client/${notification?.clientId}`)} style={{ cursor: "pointer" }} rel="noopener noreferrer" className={notification.id === hoveredNotificationId ? 'underlined' : ''} >
            Go to Clients
          </a>
        );

      case "all_complete":
        return (
          <a onClick={() => {
            // navigate(`/client/${notification?.clientId}`);
            handleNotificationClose();
          }} style={{ cursor: "pointer" }} rel="noopener noreferrer" className={notification.id === hoveredNotificationId ? 'underlined' : ''} >
            Analyze members’ results
          </a>
        );
      default:
        return null;
    }
  };


  const getNotificationDate = (notification) => {
    const date = new Date(notification?.timestamp);
    const formattedDate = date.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
      year: "numeric"
    }).replace(",", "");

    return formattedDate;
  }

  // logs
  // console.log("notifications:", notifications);

  return (
    isNotificationOpen && (
      <>
        <div className="notification-panel" ref={notificationRef} role="dialog" aria-labelledby="notification-header" style={{ height: notifications?.length > 0 ? '448px' : 'auto' }}>
          {
            isLoading ? <div className="notification-loading">
              <CircularProgress />
            </div>
              :
              <>
                <div className="notification-header">
                  <IconButton className="dustbin" onClick={() => handleDelete({ notification_type: 'all' })}>
                    <img src={Dustbin} alt="Clear all" />
                  </IconButton>
                  <h4 id="notification-header">Notifications</h4>
                  <IconButton onClick={handleNotificationClose} aria-label="Close notifications">
                    <CloseIcon />
                  </IconButton>
                </div>
                <ul className="notification-list" style={{ padding: notifications?.length === 0 ? "0 18px" : "0" }}>

                  {
                    notifications?.length > 0 ?
                      notifications.map((notification) => (
                        <li
                          className={`notification-item ${notification.id === hoveredNotificationId ? 'hovered' : ''}`}
                          key={notification.id}
                          onMouseEnter={() => setHoveredNotificationId(notification.id)}
                          onMouseLeave={() => setHoveredNotificationId(null)}
                        >
                          <div className="notification-content">
                            <p>
                              {getNotificationText(notification)}
                            </p>
                            <span className="date">{getNotificationDate(notification)}</span>
                            <div className="cta-delete-notification">
                              {/* {
                                getNotificationLink(notification)
                              } */}
                              <IconButton
                                onClick={() => handleDelete(notification)}
                                className="dustbin delete"
                                aria-label="Delete notification"
                              >
                                <img src={Dustbin} alt="Clear" />
                              </IconButton>
                            </div>
                          </div>
                        </li>
                      ))
                      :
                      <div className="empty-notification-container">
                        <img src={noNotification} alt="" className="no-notification-img" />
                        <p className="first-notification">You don’t have any notifications yet—consider this your first!</p>
                        <p className="bottom-line">We'll share updates here as soon as <br /> they're ready.</p>
                      </div>
                  }
                </ul>
              </>
          }
        </div>
        <div className="notification-overlay"></div>
      </>
    )
  );
};

export default Notification;
